import { Box, Button } from '@mui/material';
import React from 'react';

interface ActionButtonsFooterProps {
    onClose: () => void;
    status: string;
    revertHidden: boolean;
    approveHidden: boolean;
    handleRevert: () => void;
    handleApprove: (id: any) => void;
    id: any;
    cancelButtonText?: string;
    revertButtonText?: string;
    approveButtonText?: string;
    cancelButtonColor?: string;
    revertButtonColor?: string;
    approveButtonColor?: string;
    isActionInitiated: boolean;
    hasReasonText: boolean;
    scrollRef?: React.RefObject<HTMLDivElement>; 
}

const ActionButtonsFooter: React.FC<ActionButtonsFooterProps> = ({
    onClose,
    status,
    revertHidden,
    approveHidden,
    handleRevert,
    handleApprove,
    id,
    cancelButtonText = 'Cancel',
    revertButtonText = 'Revert',
    approveButtonText = 'Approve',
    cancelButtonColor = '#000',
    revertButtonColor = '#D90000',
    approveButtonColor = '#058B2B',
    isActionInitiated,
    hasReasonText,
    scrollRef,
  
}) => {
    const isStatusFinalized = status === 'Approved' || status === 'Reverted';
    const management = localStorage.getItem("management") || "Default Location Name";
    const apiManagement = localStorage.getItem("apiManagement") || "Default Location Name";

    const isManagementMatching = management === apiManagement;

    
    return (
        <Box
            position="fixed"
            bottom={0}
            padding={2}
            width="50%"
            maxWidth="800px"
            sx={{
                boxShadow: '-1px -1px 13.2px 0px rgba(0, 0, 0, 0.1)',
                bgcolor: '#fff',
                zIndex: 10,
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <Box>
                <Button
                    variant="outlined"
                    sx={{ color: cancelButtonColor, borderColor: cancelButtonColor }}
                    onClick={onClose}
                >
                    {cancelButtonText}
                </Button>
            </Box>

            <Box
                sx={{ display: 'flex', gap: '20px', justifyContent: 'end', marginRight: '20px' }}
            >
                {isManagementMatching && (
                    <>

                       {(!isStatusFinalized || status === 'Approved') && !revertHidden && (
                       <Button
                       variant="outlined"
                       sx={{
                         color: revertButtonColor,
                         padding: '7px 35px',
                         textTransform: 'none',
                         border: `1px solid ${revertButtonColor}`,
                         opacity: isActionInitiated && !hasReasonText ? 0.5 : 1,
                       }}
                       onClick={() => {
                        handleRevert();
                        setTimeout(() => {
                            scrollRef?.current?.scrollTo({
                                top: scrollRef.current.scrollHeight,
                                behavior: 'smooth',
                            });
                        }, 100);
                    }}
                       
                       disabled={isActionInitiated && !hasReasonText}
                     >
                       {revertButtonText}
                     </Button>
                     
                    )}
    
                    {(!isStatusFinalized || status === 'Reverted') && !approveHidden && (
                        <Button
                            variant="contained"
                            sx={{
                                color: '#fff',
                                padding: '7px 35px',
                                textTransform: 'none',
                                bgcolor: approveButtonColor,
                                opacity: isActionInitiated && !hasReasonText ? 0.5 : 1,
                            }}
                          //  onClick={() => handleApprove(id)}
                          onClick={() => {
                            handleApprove(id);
                            setTimeout(() => {
                                scrollRef?.current?.scrollTo({
                                    top: scrollRef.current.scrollHeight,
                                    behavior: 'smooth',
                                });
                            }, 100);
                        }}
                            disabled={isActionInitiated && !hasReasonText}
                        >
                            {approveButtonText}
                        </Button>
                    )}
                                    </>

                )}
             
            </Box>
        </Box>
    );
};

export default ActionButtonsFooter;